import type { TransactionsResponse } from '../../api/types'

/** The grantable fields the page's policy exposes to the requester (FR-38). */
export type ExposedFields = ReadonlySet<string>

export const FIELD_GATEWAY = 'gateway_name'
export const FIELD_SERVICE = 'service_name'
export const FIELD_SERVICE_TYPE = 'service_type'
/** Internal-only (FR-42): listed only for an internal user acting for a beneficiary organisation (AB-40). */
export const FIELD_BENEFICIARY = 'beneficiary_code'
export const FIELD_BENEFICIARY_NAME = 'beneficiary_name'
/** Grantable receipt fields (FR-43). */
export const FIELD_BILL_NUMBER = 'bill_number'
export const FIELD_SVC_NMB = 'svc_nmb'
export const FIELD_CUS_NMB = 'cus_nmb'
/** MPAY-33569. */
export const FIELD_COLLECTOR_COMPANY_BID = 'collector_company_bid'
/** The rest of the grantable tier: listed as columns once granted (MPAY-33570).
 *  Remittance details (`payee_note`) is not: detail panel and export only. */
export const FIELD_FEE = 'fee'
export const FIELD_COLLECTED_TOTAL = 'collected_total'
export const FIELD_PAID_AT = 'paid_at'
export const FIELD_STATUS_UPDATED_AT = 'status_updated_at'
export const FIELD_SOURCE_STATUS = 'source_status'

/**
 * Reads the page's `scope.exposed_fields` into a set. The PAGE decides what
 * is rendered, not the rows: a row may carry a value the policy withholds on
 * other rows (a grant restricted to some service types), and an empty page
 * still knows what it would have shown — which is what keeps the gateway
 * filter from vanishing when a filter matches nothing.
 */
export const exposedFields = (scope: TransactionsResponse['scope'] | undefined): ExposedFields =>
  new Set(scope?.exposed_fields ?? [])

/**
 * The grantable fields the requester may filter on (MPAY-33568): exposed on
 * every row, which `exposed_fields` cannot say. The filter bar offers a
 * grantable filter exactly when its field is here; the API refuses it otherwise.
 */
export const filterableFields = (scope: TransactionsResponse['scope'] | undefined): ExposedFields =>
  new Set(scope?.filterable_fields ?? [])
